import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {FormOptionsLists} from '../../../shared/FormOptionsLists';
import {SystemicGrammarCategoryDto} from '../../../dtos/grammar/sys/systemic-grammar-category-dto';
import {SysGrammarService} from '../../../services/grammar/sys-grammar.service';
import {NotificationService} from '../../../services/common/notification.service';
import {SystemicGrammarEntryDto} from "../../../dtos/grammar/sys/systemic-grammar-entry-dto";
import {SharedService} from "../../../services/common/shared.service";
import {FuncGrammarService} from "../../../services/grammar/func-grammar.service";
import {SelectComponent} from "../../select/select.component";
import {FolderItemType} from "../../../dtos/folder/folder";

export interface DialogData {
  id: number;
  service: FuncGrammarService | SysGrammarService
}

@Component({
    selector: 'app-new-grammar-entry',
    templateUrl: './new-grammar-entry.component.html',
    styleUrl: './new-grammar-entry.component.scss',
    standalone: false
})
export class NewGrammarEntryComponent implements OnInit {

  formOptionsLists = new FormOptionsLists();
  levelList = this.formOptionsLists.levelList.filter(o => o !== 'NONE');

  selectedCategory: SystemicGrammarCategoryDto;

  grammarEntryFormGroup: UntypedFormGroup;
  edit;
  service: SysGrammarService | FuncGrammarService

  entry: SystemicGrammarEntryDto;

  get folderItemType(): FolderItemType {
    return this.service instanceof FuncGrammarService ? 'FUNCTIONAL_GRAMMAR_ENTRY' : 'SYSTEMIC_GRAMMAR_ENTRY';
  }

  constructor(@Inject(MAT_DIALOG_DATA) public injectedData: DialogData,
              private sysGrammarService: SysGrammarService,
              private funcGrammarService: FuncGrammarService,
              private notificationService: NotificationService,
              private dialog: MatDialog, private sharedService: SharedService,
              private _formBuilder: UntypedFormBuilder, private dialogRef: MatDialogRef<NewGrammarEntryComponent>) {
  }

  ngOnInit() {
    this.grammarEntryFormGroup = this._formBuilder.group({
      nameCtrl: ['', Validators.required, Validators.max(256)],
      productiveCtrl: [''],
      exampleCtrl: ['', Validators.max(256)],
      categoryCtrl: ['', Validators.required],
      commentCtrl: ['', Validators.max(256)]
    });
    if (this.injectedData !== null) {
      this.service = this.injectedData.service
      this.service.getEntry(this.injectedData.id).subscribe({
        next: (entry) => {
          this.entry = entry;
          this.selectedCategory = this.entry.category;
          this.edit = true;
          this.grammarEntryFormGroup = this._formBuilder.group({
            nameCtrl: new UntypedFormControl(this.entry.name, [Validators.required, Validators.max(256)]),
            productiveCtrl: new UntypedFormControl(this.entry.productive),
            exampleCtrl: new UntypedFormControl(this.entry.example, [Validators.required, Validators.max(256)]),
            commentCtrl: new UntypedFormControl(this.entry.comment, [Validators.max(256)]),
            categoryCtrl: new UntypedFormControl([this.entry.category, Validators.required])
          });
          this.sharedService.toggleAllSelection(this.grammarEntryFormGroup.controls.categoryCtrl, [this.selectedCategory]);
        },
        error: (error) => {
          this.notificationService.openSnackBar(error);
        }
      });

    }
    this.grammarEntryFormGroup.get('categoryCtrl')?.disable();
  }

  openCategorySelectionDialog() {
    let selectionEnt: string;
    if (this.service instanceof SysGrammarService) {
      selectionEnt = 'systemic_grammar_category';
    } else {
      selectionEnt = 'functional_grammar_category'
    }
    const dialogRef = this.dialog.open(SelectComponent, {
      data: {
        selectedObjects: this.selectedCategory,
        displayedColumns: ['single-select', 'voc-cat-name', 'voc-cat-parent'],
        selectionEntity: selectionEnt,
        dialogTitle: 'Thema auswählen',
        selectionMode: 'single-select',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) { // TODO check if extractable into shared service
        if (result.length > 0) {
          this.selectedCategory = result[0];
          this.sharedService.toggleAllSelection(this.grammarEntryFormGroup.controls.categoryCtrl, [this.selectedCategory]);
        } else {
          this.selectedCategory = null;
          this.sharedService.toggleAllSelection(this.grammarEntryFormGroup.controls.categoryCtrl, []);
        }
      }
    });
  }

  save() {
    if (this.injectedData !== null) {
      this.service.updateEntry({
        id: this.entry.id,
        name: this.grammarEntryFormGroup.controls.nameCtrl.value,
        categoryId: this.grammarEntryFormGroup.controls.categoryCtrl?.value[0],
        productive: (this.grammarEntryFormGroup.controls.productiveCtrl?.value === '') ? 'NONE' : this.grammarEntryFormGroup.controls.productiveCtrl?.value,
        example: this.grammarEntryFormGroup.controls.exampleCtrl?.value,
        comment: this.grammarEntryFormGroup.controls.commentCtrl?.value
      }).subscribe({
        next: c => {
          this.notificationService.openSnackBar('Eintrag ' + c.name + ' erfolgreich bearbeitet');
          this.dialogRef.close(c);
        }, error: error => {
          this.notificationService.openSnackBar(error);
        }
      });
    } else {
      this.service.createEntry({
        name: this.grammarEntryFormGroup.controls.nameCtrl.value,
        categoryId: this.grammarEntryFormGroup.controls.categoryCtrl?.value[0],
        productive: (this.grammarEntryFormGroup.controls.productiveCtrl?.value === '') ? 'NONE' : this.grammarEntryFormGroup.controls.productiveCtrl?.value,
        example: this.grammarEntryFormGroup.controls.exampleCtrl?.value,
        comment: this.grammarEntryFormGroup.controls.commentCtrl?.value
      }).subscribe({
          next: c => {
            this.notificationService.openSnackBar('Eintrag ' + c.name + ' erfolgreich gespeichert');
            this.dialogRef.close(c);
          },
          error: error => {
            this.notificationService.openSnackBar(error);
          }
        }
      );
    }
  }

}
